(function () {
	'use strict';

	angular
		.module('app').constant('appConfig', (() => {
			const initParams = window._initParams = (typeof window.initParams === "undefined") ?
				{
					site: 'www.esri.com',
					gsaTier: 'prd'
				} : window.initParams;

			let arcgisTypeIcons = {
				["Web Mapping Application"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/apps16.png",
				["Map Image Layer"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/mapimages16.png",
				["Web Map"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/maps16.png",
				["Map Service"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/maptiles16.png",
				["CityEngine Web Scene"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/maptiles16.png",
				["Feature Service"]: "https://cdn.arcgis.com/cdn/20886/js/jsapi/esri/css/images/item_type_icons/featureshosted16.png"
			};
			let arcgisThumbnailPlaceholders = ['//static.arcgis.com/images/desktopapp.png']

			return {
				gsaTier: initParams.gsaTier,
				searchParams: EsriSearchParams.find(params => {
					return params.site === initParams.site
				}),
				enSynonyms: searchSynonyms(english_synonym_list) || '',
				arcgisSearchExtensionParams: arcgisSearchExtensionParams,
				arcgisTypeIcons: arcgisTypeIcons,
				arcgisThumbnailPlaceholders

			}
		})()
	);

})();
